export const SHOW_REJECT_ACCEPT_BUTTON = "SHOW_REJECT_ACCEPT_BUTTON";

export const USER_PROFILE = "USER_PROFILE";
export const USER_LOGOUT = "USER_LOGOUT";

export const GET_LIST_PROVINCES = "GET_LIST_PROVINCES";
export const GET_LIST_DISTRICTS = "GET_LIST_DISTRICTS";

export const FETCH_USER_PAYMENT = "FETCH_USER_PAYMENT";
export const FETCH_USER_PAYMENTS = "FETCH_USER_PAYMENTS";
export const UPDATE_USER_PAYMENT = "UPDATE_USER_PAYMENT";
export const FETCH_INVOICE_ADDRESS = "FETCH_INVOICE_ADDRESS";
export const UPDATE_INVOICE_ADDRESS = "UPDATE_INVOICE_ADDRESS";
export const PAY = "PAY";
export const PAYPAL = "PAYPAL";
export const SEND_INVOICE = "SEND_INVOICE";
export const SEND_INVOICE_OR_MESSAGE_TO_USER = "SEND_INVOICE_OR_MESSAGE_TO_USER";
export const GET_PREBOOKING_DATES = "GET_PREBOOKING_DATES";

export const GET_PACKAGES = "GET_PACKAGES";
export const GET_AGENCY_PACKAGES = "GET_AGENCY_PACKAGES";
export const GENERATE_INVOICE = "GENERATE_INVOICE";
export const MAKE_PAYMENT_FOR_COIN_PACKAGE = "MAKE_PAYMENT_FOR_COIN_PACKAGE";

export const USER_ADD_LISTING = "USER_ADD_LISTING";
export const TRANSLATE_LISTING = "TRANSLATE_LISTING";
export const GET_LISTING_PREVIEW = "GET_LISTING_PREVIEW";
export const USER_UPDATE_LISTING = "USER_UPDATE_LISTING";
export const USER_CONFIRM_LISTING = "USER_CONFIRM_LISTING";

export const GET_CATEGORY_CHILD_BY_ID = "GET_CATEGORY_CHILD_BY_ID";

export const GET_LISTING_HOT_DEALS = "GET_LISTING_HOT_DEALS";
export const GET_AFFILIATE_LISTING = "GET_AFFILIATE_LISTING";
export const GET_LISTING_HOME = "GET_LISTING_HOME";
export const GET_LIST_BANNER = "GET_LIST_BANNER";

export const GET_SELLER_LISTING = "GET_SELLER_LISTING";

export const GET_REPORT_TYPE = "GET_REPORT_TYPE";

export const GET_LISTING_DETAILS_FOR_FRONT = "GET_LISTING_DETAILS_FOR_FRONT";

export const GET_COIN_PACKAGES = "GET_COIN_PACKAGES";

export const GET_CATEGORY = "GET_CATEGORY";


export const GET_LISTING_INTERESTINGS = "GET_LISTING_INTERESTINGS";

export const GET_LISTING_SELLER_DETAIL_ORTHER = "GET_LISTING_SELLER_DETAIL_ORTHER";

export const CREATE_FAVOURITES_USER = "CREATE_FAVOURITES_USER";

export const DELETE_FAVOURITES_USER = "DELETE_FAVOURITES_USER";

export const GET_USER_LISTING = "GET_USER_LISTING";
export const SOLD_LISTING = "SOLD_LISTING";
export const DELETE_LISTING = "DELETE_LISTING"

export const GET_LISTING_USER_MESSAGE = "GET_LISTING_USER_MESSAGE";

export const GET_LISTING_USER_MESSAGE_DETAIL = "GET_LISTING_USER_MESSAGE_DETAIL";

export const MARK_READ_USER_MESSAGE = "MARK_READ_USER_MESSAGE";

export const CREATE_REPORT_LISTING_DETAIL = "CREATE_REPORT_LISTING_DETAIL";

export const CREATE_MESSAGE_LISTING_DETAIL = "CREATE_MESSAGE_LISTING_DETAIL";

// Admin listings waiting for approve
export const GET_LISTINGS_WAITING_FOR_APPROVE = "GET_LISTINGS_WAITING_FOR_APPROVE";
export const ADMIN_RENEW_LISTING = "ADMIN_RENEW_LISTING";
export const ADMIN_REJECT_LISTING = "ADMIN_REJECT_LISTING";
export const ADMIN_DELETE_LISTING = "ADMIN_DELETE_LISTING";
export const ADMIN_APPROVE_LISTING = "ADMIN_APPROVE_LISTING";
export const ADMIN_GET_LISTING_DETAIL = "ADMIN_GET_LISTING_DETAIL";
export const FETCH_ADVANCED_USER_PAYMENTS = "FETCH_ADVANCED_USER_PAYMENTS";
export const FETCH_ADVANCED_USER_PAYMENTS_DETAILS = "FETCH_ADVANCED_USER_PAYMENTS_DETAILS";
export const ADMIN_APPROVE_COUNT_LISTING = "ADMIN_APPROVE_COUNT_LISTING";
export const GET_NUMBER_OF_LISTING_OF_USER = "GET_NUMBER_OF_LISTING_OF_USER";


export const GET_DATA_SEARCH_CATEGORY = "GET_DATA_SEARCH_CATEGORY";

export const GET_DATA_PROVINCES = "GET_DATA_PROVINCES";

export const GET_DATA_DISTRISTS = "GET_DATA_DISTRISTS";

export const GET_DATA_AMPHURES = "GET_DATA_AMPHURES";

export const GET_LISTING_ATTR = "GET_LISTING_ATTR";

export const GET_TEXT_SEARCH = "GET_TEXT_SEARCH";

export const GET_ID_ATTR = "GET_ID_ATTR";

export const GET_DATA_USER_DASHBOARD = "GET_DATA_USER_DASHBOARD";



// user contact topic

export const GET_DATA_USER_CONTACT_TOPIC = "GET_DATA_USER_CONTACT_TOPIC";

export const GET_DATA_USER_CONTACT_ADVERTISEMENT = "GET_DATA_USER_CONTACT_ADVERTISEMENT";

export const GET_DATA_USER_CONTACT_PERIOD = "GET_DATA_USER_CONTACT_PERIOD";

export const POST_DATA_CONTACT = "POST_DATA_CONTACT";

export const RENEW_LISTING = "RENEW_LISTING";

export const GET_ADMIN_REPORT_LISTING = "GET_ADMIN_REPORT_LISTING";

export const GET_ADMIN_CONTACT_REPORT = "GET_ADMIN_CONTACT_REPORT";

export const GET_ADMIN_CONTACT_ADVERTISEMENT = "GET_ADMIN_CONTACT_ADVERTISEMENT";

export const GET_ADMIN_REPORT_LISTING_DETAIL = "GET_ADMIN_REPORT_LISTING_DETAIL";

export const MARK_AS_CHECKED_ADMIN_REPORT = "MARK_AS_CHECKED_ADMIN_REPORT";

export const GET_ADMIN_CONTACT_REPORT_DETAIL = "GET_ADMIN_CONTACT_REPORT_DETAIL";

export const MARK_AS_PROCESSED_ADMIN_CONTACT_REPORT = "MARK_AS_PROCESSED_ADMIN_CONTACT_REPORT";

export const GET_ADMIN_CONTACT_ADVERTISEMENT_DETAIL = "GET_ADMIN_CONTACT_ADVERTISEMENT_DETAIL";

export const GET_EMAIL_TEMPLATE = "GET_EMAIL_TEMPLATE";

export const GET_DATA_SEARCH_ADMIN = "GET_DATA_SEARCH_ADMIN";

export const GET_DATA_USER_MANAGER = "GET_DATA_USER_MANAGER";

export const SET_USER_TO_ADMIN = 'SET_USER_TO_ADMIN';

export const GET_USER_BY_EMAIL = 'GET_USER_BY_EMAIL';

export const ADMIN_GET_BANNER_TYPES = "ADMIN_GET_BANNER_TYPES";

export const ADMIN_BANNER_TYPE_ACTIVE = "ADMIN_BANNER_TYPE_ACTIVE";

export const ADMIN_UPDATE_BANNER_TYPE = "ADMIN_UPDATE_BANNER_TYPE";

export const UPDATE_INFO_USER_ADMIN = "UPDATE_INFO_USER_ADMIN";

export const DELETE_USER_ADMIN = "DELETE_USER_ADMIN";

export const UPLOAD_AVARTA_USER = "UPLOAD_AVARTA_USER";

export const GET_DATA_ADMIN_DASHBOARD = "GET_DATA_ADMIN_DASHBOARD";

export const ADMIN_GET_ANALYTICS_LISTING = "ADMIN_GET_ANALYTICS_LISTING";

export const ADMIN_GET_ANALYTICS_PAYMENT = "ADMIN_GET_ANALYTICS_PAYMENT";

export const GET_USER_LISTING_PACKAGE = "GET_USER_LISTING_PACKAGE";
export const PAYMENT_NEW_PACKAGE = "PAYMENT_NEW_PACKAGE";

export const SET_PROJECT_CONFIG = "SET_PROJECT_CONFIG";
export const GET_PROJECT_CONFIG = "GET_PROJECT_CONFIG";
export const GET_SITE_CONFIG = "GET_SITE_CONFIG";
export const GET_SITE_TIPS = "GET_SITE_TIPS";
export const UPDATE_SITE_TIPS = "UPDATE_SITE_TIPS";
export const UPDATE_SITE_CONFIG = "UPDATE_SITE_CONFIG";

export const GET_ADS = "GET_ADS"

export const USER_GET_ANALYTICS_KEYWORD = "USER_GET_ANALYTICS_KEYWORD"

export const USER_GET_ANALYTICS_LISTING = "USER_GET_ANALYTICS_LISTING"

export const USER_POST_CONTACT_IN_FAQ = "USER_POST_CONTACT_IN_FAQ"

export const GET_ALL_BANNER = "GET_ALL_BANNER"

export const UPDATE_HIT_BANNER = "UPDATE_HIT_BANNER";

export const GET_NOT_SEEN = "GET_NOT_SEEN";
export const UPDATE_NOT_SEEN = "UPDATE_NOT_SEEN";


//Ads Controller

export const GET_LIST_OF_CUSTOMER = "GET_LIST_OF_CUSTOMER"
export const GET_LIST_ADS_OF_CUSTOMER = "GET_LIST_ADS_OF_CUSTOMER"
export const UPDATE_GOOGLE_CLIENT_ID = "UPDATE_GOOGLE_CLIENT_ID"
export const GET_GOOGLE_CLIENT_ID = "GET_GOOGLE_CLIENT_ID"
export const CREATE_CUSTOMER = "CREATE_CUSTOMER"
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
export const DELETE_CUSTOMER = "DELETE_CUSTOMER"
export const GET_ADVERTISMENT_LOCATIONS_FOR_SCREEN = "GET_ADVERTISMENT_LOCATIONS_FOR_SCREEN"
export const GET_ADVERTISMENT_FOR_LOCATIONS = "GET_ADVERTISMENT_FOR_LOCATIONS"
export const CREATE_ADVERTISMENT_FOR_LOCATIONS = "CREATE_ADVERTISMENT_FOR_LOCATIONS"
export const DELETE_ADVERTISMENT_FOR_LOCATIONS = "DELETE_ADVERTISMENT_FOR_LOCATIONS"
export const GET_CUSTOMER_LIST_FOR_ADS = "GET_CUSTOMER_LIST_FOR_ADS"
export const MAKE_ADS_ACTIVE = "MAKE_ADS_ACTIVE"
export const MAKE_ADS_INACTIVE = "MAKE_ADS_INACTIVE"
export const SWITCH_GOOGLE_ADS = "SWITCH_GOOGLE_ADS"
export const GETADS_FOR_PUBLIC_WEBSITE = "GETADS_FOR_PUBLIC_WEBSITE"
export const GETADS_FOR_PUBLIC_WEBSITE_MULTIPLE = "GETADS_FOR_PUBLIC_WEBSITE_MULTIPLE"
export const CLICK_BANNERADS = "CLICK_BANNERADS"
export const GET_BROWSER_ID = "GET_BROWSER_ID"
export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS"
export const GET_IMPRESSIONS = "GET_IMPRESSIONS"
export const GET_CLICK = "GET_CLICK"
export const GET_CTR = "GET_CTR"
export const GENERATE_ADS_REPORT = "GENERATE_ADS_REPORT"
export const SEND_ADS_REPORT = "SEND_ADS_REPORT"
export const GET_GOOGLE_CLIENT_ID_PUBLIC = "GET_GOOGLE_CLIENT_ID_PUBLIC"
export const ADS_CONTACT = "ADS_CONTACT"


//chat controller
export const GET_CHAT_HISTORY_USER ="GET_CHAT_HISTORY_USER"
export const GET_CHAT ="GET_CHAT"
export const BLOCK_USER ="BLOCK_USER"
export const SEND_CHAT_MESSAGE ="SEND_CHAT_MESSAGE"
export const GET_NUMBER_OF_UNREAD_MESSAGE ="GET_NUMBER_OF_UNREAD_MESSAGE"


//Alert
export const CREATE_ALERT="CREATE_ALERT";
export const UPDATE_ALERT="UPDATE_ALERT";
export const ENABLE_DISABLE_ALERT="ENABLE_DISABLE_ALERT";
export const DELETE_ALERT="DELETE_ALERT";
export const GET_ALERTS="GET_ALERTS";
export const GET_SPECIFIC_ALERT="GET_SPECIFIC_ALERT";
export const GET_ALERT_MACTHES="GET_ALERT_MACTHES";


//Admin Agency
export const GET_AGENCIES = "GET_AGENCIES";
export const GET_ONE_AGENCY = "GET_ONE_AGENCY";
export const DELETE_ONE_AGENCY = "DELETE_ONE_AGENCY";
export const ADD_AGENCY = "ADD_AGENCY";
export const UPDATE_AGENCY = "UPDATE_AGENCY";
export const ADD_AGENT_TO_AGENCY = "ADD_AGENT_TO_AGENCY";
export const GET_AGENT_FOR_AGENCY = "GET_AGENT_FOR_AGENCY";
export const DELETE_AGENT_FOR_AGENCY = "DELETE_AGENT_FOR_AGENCY";
export const VERIFY_USER_AGENCY = "VERIFY_USER_AGENCY";
export const GET_USER_FOR_AGENCY_BY_EMAIL = "GET_USER_FOR_AGENCY_BY_EMAIL";
export const USER_CREATE_AGENCY = "USER_CREATE_AGENCY";
export const USER_UPDATE_AGENCY = "USER_UPDATE_AGENCY";
export const APPROVE_OR_REJECT_AGENCY = "APPROVE_OR_REJECT_AGENCY";
export const ACTIVE_AGENTS_INVITATION = "ACTIVE_AGENTS_INVITATION";
export const GET_PENDING_AGENTS = "GET_PENDING_AGENTS";
export const DELETE_PENDING_INVITATION_OF_AGENT = "DELETE_PENDING_INVITATION_OF_AGENT";
export const GET_LISTING_ERROR_XML = "GET_LISTING_ERROR_XML";

//Admin Media

export const GET_MEDIA = "GET_MEDIA";
export const ADD_FILES = "ADD_FILES";
export const DELETE_FILE = "DELETE_FILE";
export const UPDATE_FILES = "UPDATE_FILES";

//Admin change listing category

export const CHANGE_LISTING_CATEGORY = "CHANGE_LISTING_CATEGORY";
export const SEARCH_LISTING_FOR_CLASSIFIEDS = "SEARCH_LISTING_FOR_CLASSIFIEDS";

//Admin hot deals

export const ADD_HOT_DEALS = "ADD_HOT_DEALS";
export const GET_LIST_OF_HOT_DEALS = "GET_LIST_OF_HOT_DEALS";
export const UPDATE_HOT_DEALS = "UPDATE_HOT_DEALS";
export const DELTE_HOT_DEALS = "DELTE_HOT_DEALS";
export const TOGGLE_HOTDEALS_ACTIVE = "TOGGLE_HOTDEALS_ACTIVE";


//Admin discount code

export const GET_DISCOUNT_CODE = "GET_DISCOUNT_CODE";
export const GET_DISCOUNT_CODE_DETAILS = "GET_DISCOUNT_CODE_DETAILS";
export const DELETE_DISCOUNT = "DELETE_DISCOUNT";
export const ENABLE_DISABLE_DISCOUNT_CODE = "ENABLE_DISABLE_DISCOUNT_CODE";
export const UPDATE_DISCOUNT_CODE = "UPDATE_DISCOUNT_CODE";
export const CREATE_DISCOUNT_CODE = "CREATE_DISCOUNT_CODE";